import styled from 'styled-components/native';
import { View, Text, Pressable } from 'react-native';

import {
  elRed,
  elGray,
  elLightGray
} from '../../styles/colors';

export const ButtonContainer = styled(View)`

`;

export const AssetsContainer = styled(View)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const AssetsShowContainer = styled(View)`
  display: flex;

  border: 4px solid black;
  border-radius: 10px;
  padding: 20px;
  gap: 40px;
  min-height: 200px;
`;

export const AssetDetailsContainer = styled(View)`
flex-direction: row;
`

export const SaleDetailsContainer = styled(View)`
  background-color: ${elLightGray};
  display: flex;
  flex-direction: row;
  border-radius: 5px;
  padding: 10px;
`

export const AssetsTabButtonContainer = styled(View)`
  flex-direction: row;
  align-items: flex-start;
  margin-top: 20px;
`

export const AssetsTabButton = styled(Pressable)`
  border: solid black 2px;
  width: 20%;
  border-radius: 3px;
  padding: 5px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  background-color: ${props => props.active ? elRed : elLightGray};
`

export const AssetsTabText = styled(Text)`
  font-weight: 900:
  font-size: 20px;
  color: ${props => props.active ? 'white' : 'black'};
`